import React, { useState } from "react";
import { ValidationResult } from "sprint-common-web";

import { EmbeddedSubtitle } from "../../../../../../../../common/api/master-api/file-records/details/GetFileRecordDetailsResponse";
import { UpdateFileRecordSubtitleRequest } from "../../../../../../../../common/api/master-api/file-records/update/subtitle/UpdateFileRecordSubtitleRequest";
import { useFileRecordApi } from "../../../../../../../../common/api/master-api/file-records/useFileRecordApi";
import { ensureVideoFileRecordDetails } from "../../../../../../../common/file-record-details/FileRecordDetails";
import { useFileRecordDetailsState } from "../../../../../hooks/useFileRecordDetailsState";
import { EmbeddedSubtitleForm } from "./EditEmbeddedSubtitleForm";

export interface EditEmbeddedSubtitleAsideContentProps {
    fileRecordId: string;
    onCancel(): void;
    onSubmit(): void;
}

export const EditEmbeddedSubtitleAsideContent = (props: EditEmbeddedSubtitleAsideContentProps): JSX.Element => {
    const { fileRecordId, onSubmit, onCancel } = props;

    const { fileRecordDetails, setFileRecordDetails } = useFileRecordDetailsState();
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [validationResult, setValidationResult] = useState<ValidationResult>();
    const { updateFileRecordSubtitle } = useFileRecordApi();

    const updateSubtilte = (subtitle?: EmbeddedSubtitle) => {
        ensureVideoFileRecordDetails(fileRecordDetails);

        const request: UpdateFileRecordSubtitleRequest = {
            id: fileRecordId,
            subtitle
        };

        setIsLoading(true);

        updateFileRecordSubtitle(request)
            .then(() => {
                setFileRecordDetails({
                    ...fileRecordDetails,
                    subtitle
                });

                onSubmit();
            })
            .catch((res) => {
                setValidationResult(res);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <EmbeddedSubtitleForm
            isLoading={isLoading}
            onCancel={onCancel}
            onSubmit={updateSubtilte}
            validationResult={validationResult}
        />
    );
};
